module.exports = __webpack_public_path__ + "static/media/dell.410718d5.jpeg";